module.exports = __webpack_public_path__ + "3af3fedc688221da3a83752440a1fe75.svg";